/**
 * @generated SignedSource<<211daa06dd1e3e1df0a99788d720e858>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlacementOutputFileType = "ONE_FILE_FOR_ALL_DESIGN" | "ONE_FILE_FOR_EACH_DESIGN";
export type PlacementOutputInputCreateInput = {
  dpi: number;
  heightCM: number;
  isEnabled: number;
  jsonArea?: string | null;
  modelID: number;
  name: string;
  placementOutputAreaItems: ReadonlyArray<PlacementOutputAreaItemInput>;
  placementOutputItems: ReadonlyArray<PlacementOutputItemInput>;
  placementOutputLayers: ReadonlyArray<PlacementOutputLayerInput>;
  settings?: PlacementSettingsInput | null;
  templateBottomFileID?: any | null;
  templateBottomFileObjectID?: number | null;
  templateBottomJsonArea?: string | null;
  templateFileID?: any | null;
  templateFileObjectID?: number | null;
  widthCM: number;
};
export type PlacementSettingsInput = {
  backgroundAsFillBackgroundTool: boolean;
  placementOutputFileType: PlacementOutputFileType;
};
export type PlacementOutputAreaItemInput = {
  areaID: number;
  colorID: number;
  json: string;
  placementOutputAreaItemID: number;
  sideID: number;
  svg: string;
};
export type PlacementOutputItemInput = {
  colorID?: number | null;
  json: string;
  placementOutputItemID: number;
};
export type PlacementOutputLayerInput = {
  colorID: number;
  fileID?: any | null;
  fileObjectID?: number | null;
  jsonArea?: string | null;
  placementOutputLayerID: number;
  templateBottomFileID?: any | null;
  templateBottomFileObjectID?: number | null;
  templateBottomJsonArea?: string | null;
};
export type placementCreatePlacementOutputMutation$variables = {
  input?: PlacementOutputInputCreateInput | null;
  inputCompressed?: string | null;
};
export type placementCreatePlacementOutputMutation$data = {
  readonly createPlacementOutput: {
    readonly placementOutput: {
      readonly dpi: number;
      readonly heightCM: number;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly jsonArea: string | null;
      readonly modelID: number;
      readonly name: string;
      readonly placementOutputAreaItems: ReadonlyArray<{
        readonly areaID: number;
        readonly colorID: number;
        readonly json: string;
        readonly placementOutputAreaItemID: number;
        readonly sideID: number;
        readonly svg: string;
      }>;
      readonly placementOutputItems: ReadonlyArray<{
        readonly colorID: number | null;
        readonly json: string;
        readonly placementOutputItemID: number;
      }>;
      readonly placementOutputLayers: ReadonlyArray<{
        readonly colorID: number;
        readonly fileID: any | null;
        readonly fileObjectID: number | null;
        readonly jsonArea: string | null;
        readonly placementOutputLayerID: number;
        readonly templateBottomFileID: any | null;
        readonly templateBottomFileObjectID: number | null;
        readonly templateBottomJsonArea: string | null;
      }>;
      readonly settings: {
        readonly backgroundAsFillBackgroundTool: boolean;
        readonly placementOutputFileType: PlacementOutputFileType;
      } | null;
      readonly templateBottomFileID: any | null;
      readonly templateBottomFileObjectID: number | null;
      readonly templateBottomJsonArea: string | null;
      readonly templateFileID: any | null;
      readonly templateFileObjectID: number | null;
      readonly widthCM: number;
    } | null;
  };
};
export type placementCreatePlacementOutputMutation = {
  response: placementCreatePlacementOutputMutation$data;
  variables: placementCreatePlacementOutputMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inputCompressed"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateBottomFileObjectID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateBottomFileID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateBottomJsonArea",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsonArea",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "inputCompressed",
        "variableName": "inputCompressed"
      }
    ],
    "concreteType": "PlacementOutput_Output",
    "kind": "LinkedField",
    "name": "createPlacementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modelID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "widthCM",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heightCM",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dpi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateFileObjectID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateFileID",
            "storageKey": null
          },
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputAreaItem",
            "kind": "LinkedField",
            "name": "placementOutputAreaItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputAreaItemID",
                "storageKey": null
              },
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sideID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "areaID",
                "storageKey": null
              },
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "svg",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputItem",
            "kind": "LinkedField",
            "name": "placementOutputItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputItemID",
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputLayer",
            "kind": "LinkedField",
            "name": "placementOutputLayers",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileID",
                "storageKey": null
              },
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileObjectID",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputLayerID",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementSettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputFileType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundAsFillBackgroundTool",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementCreatePlacementOutputMutation",
    "selections": (v7/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "placementCreatePlacementOutputMutation",
    "selections": (v7/*:: as any*/)
  },
  "params": {
    "cacheID": "94eeb638d5def512343bd9d9365f22f8",
    "id": null,
    "metadata": {},
    "name": "placementCreatePlacementOutputMutation",
    "operationKind": "mutation",
    "text": "mutation placementCreatePlacementOutputMutation(\n  $input: PlacementOutputInputCreateInput\n  $inputCompressed: String\n) {\n  createPlacementOutput(input: $input, inputCompressed: $inputCompressed) {\n    placementOutput {\n      id\n      modelID\n      widthCM\n      heightCM\n      dpi\n      isEnabled\n      templateFileObjectID\n      templateBottomFileObjectID\n      templateBottomFileID\n      templateBottomJsonArea\n      templateFileID\n      jsonArea\n      name\n      placementOutputAreaItems {\n        placementOutputAreaItemID\n        colorID\n        sideID\n        areaID\n        json\n        svg\n      }\n      placementOutputItems {\n        placementOutputItemID\n        json\n        colorID\n      }\n      placementOutputLayers {\n        colorID\n        fileID\n        jsonArea\n        fileObjectID\n        templateBottomFileObjectID\n        templateBottomFileID\n        templateBottomJsonArea\n        placementOutputLayerID\n      }\n      settings {\n        placementOutputFileType\n        backgroundAsFillBackgroundTool\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c42a8f6568aa9798f0d2632fb53e2d43";

export default node;
